import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
//import moment from 'moment';

// import moment from "moment";
import moment from "moment-timezone";
// import * as subscriptions from './graphql/subscriptions';
// import { eventBus } from './main';
import * as hasura_queries from "./graphql_hasura/queries";




import { auth_module } from "./storejs_modules/auth_store.js";


// = new CognitoIdentityProviderClient({region: process.env.VUE_APP_AWS_REGION});

Vue.use(Vuex);

var sem_status = {};

const updateImageList = (existingImages, newImages, offset) => {
  const combinedImages =
    existingImages.length > 0 ? existingImages[0].concat(newImages) : newImages;
  return [combinedImages, offset, combinedImages.length];
};

const updateVideoList = (existingVideos, newVideos, offset) => {
  const combinedVideos =
    existingVideos.length > 0 ? existingVideos[0].concat(newVideos) : newVideos;
  return [combinedVideos, offset, combinedVideos.length];
};

const buildEstrusQuery = (filters, videos = false) => {
  let whereClauses = [`gpt_check: {_eq: true}`];
  if (filters) {
    let orConditions = [];

    Object.entries(filters.estrus).forEach(([key, value]) => {
      if (
        ["mounting", "resting_chin", "in_heat"].includes(key) &&
        value === true
      ) {
        orConditions.push(`{class_label: {_eq: "${key}"}}`);
      }
    });

    if (orConditions.length > 0) {
      whereClauses.push(`_or: [${orConditions.join(", ")}]`);
    }

    if (filters.class_conf) {
      const operator = filters.class_conf.includes(">= ") ? "_gte" : "_lte";
      const value = parseFloat(filters.class_conf.slice(3));
      whereClauses.push(`class_conf: {${operator}: ${value}}`);
    }
  }

  const mediaType = videos ? "VIDEO" : "IMAGE";
  whereClauses.push(`media_type: {_eq: "${mediaType}"}`);

  let whereClause = `{${whereClauses.join(", ")}}`;

  let query = `
  query ($limit: Int!, $offset: Int!) {
    analytics_estrus(limit: $limit, offset: $offset, order_by: {media_timestamp: desc}, where: ${whereClause}) {
      camera_id
      bbox_x
      bbox_y
      bbox_w
      bbox_h
      class_conf
      class_label
      conf_check
      gpt_check
      gpt_description
      oo_bbox_h
      oo_bbox_w
      oo_bbox_x
      oo_bbox_y
      oo_tracking_id
      recent_sent_check
      s3_uri
      media_timestamp
      tracking_id
      species_label
      species_conf
      class_label_2
      class_conf_2
      customer {
        id
        first_name
        last_name
      }
    }
  }`;

  return query;
};

const buildQuery = (filters, videos = false) => {
  // console.log(filters)
  let classificationArray = ["species_label", "species_conf"];
  // Base query structure

  let query = `
  query ($limit: Int!, $offset: Int!) {
    inference_media(limit: $limit, offset: $offset, order_by: {media_timestamp: desc}`;

  const constructWhereClause = (classification, values) => {
    if (
      classification === "conf" ||
      classification === "class_label" ||
      classification === "body_parts" ||
      classification === "estrus" ||
      classification === "body_parts_conf" ||
      classification === "Time" ||
      classification === "Tag1" ||
      classification === "Tag2"
    ) {
      return "";
    }
    const conditions = Object.entries(values)
      .filter(([, value]) => value) // Simplified filter to check only the value
      .map(([key]) => {
        if (!classificationArray.includes(classification)) {
          classificationArray.push(classification);
        }

        return key === "null"
          ? `{${classification}: {_is_null: true}}`
          : `{${classification}: {_eq: "${key}"}}`;
      });

    return conditions.length > 0 ? `{ _or: [${conditions.join(", ")}] }` : "";
  };

  // Constructing the where clause dynamically based on filters

  const whereClauses = Object.entries(filters)
    .map(([classification, values]) =>
      constructWhereClause(classification, values)
    )
    .filter((clause) => clause.length > 0);

  if (filters.conf) {
    Object.entries(filters.conf).forEach(([key, value]) => {
      if (value != null) {
        if (
          key === "class_conf" ||
          key === "bbox_ratio" ||
          key === "tail_ratio"
        ) {
          return;
        }
        if (!classificationArray.includes(key)) {
          classificationArray.push(key);
        }
        let condition;
        if (value.startsWith(">= ")) {
          condition = `{${key}: {_gte: "${value.slice(3)}"}}`;
        } else if (value.startsWith("<= ")) {
          condition = `{${key}: {_lte: "${value.slice(3)}"}}`;
        }

        if (condition) {
          whereClauses.push(condition);
        }
      }
    });
  }
  let classLabelConditions = [];
  if (filters.class_label) {
    Object.entries(filters.class_label).forEach(([key, value]) => {
      if (value === true) {
        classLabelConditions.push(`class_label: {_eq: "${key}"}`);
      }
    });

    if (filters.conf && filters.conf.class_conf) {
      let condition;
      if (filters.conf.class_conf.startsWith(">= ")) {
        condition = `class_conf: {_gte: "${filters.conf.class_conf.slice(3)}"}`;
      } else if (filters.conf.class_conf.startsWith("<= ")) {
        condition = `class_conf: {_lte: "${filters.conf.class_conf.slice(3)}"}`;
      }
      classLabelConditions.push(condition);
      // combinedWhereClause = combinedWhereClause.replace("{", `{ ${condition}`);
    }

    if (filters.conf && filters.conf.bbox_ratio) {
      let condition;
      if (filters.conf.bbox_ratio.startsWith(">= ")) {
        condition = `bbox_ratio: {_gte: "${filters.conf.bbox_ratio.slice(3)}"}`;
      } else if (filters.conf.bbox_ratio.startsWith("<= ")) {
        condition = `bbox_ratio: {_lte: "${filters.conf.bbox_ratio.slice(3)}"}`;
      }
      classLabelConditions.push(condition);
      // combinedWhereClause = combinedWhereClause.replace("{", `{ ${condition}`);
    }

    let bodyPartsConditions = [];

    // Handle filters.conf
    if (filters.conf && filters.conf.tail_ratio) {
      let condition;
      if (filters.conf.tail_ratio.startsWith(">= ")) {
        condition = `tail_ratio: {_gte: "${filters.conf.tail_ratio.slice(3)}"}`;
      } else if (filters.conf.tail_ratio.startsWith("<= ")) {
        condition = `tail_ratio: {_lte: "${filters.conf.tail_ratio.slice(3)}"}`;
      }
      if (condition) {
        bodyPartsConditions.push(condition);
      }
    }

    if (filters.body_parts) {
      for (const key in filters.body_parts) {
        if (filters.body_parts[key] === true) {
          bodyPartsConditions.push(`${key}: {_is_null: false}`);
        }
      }
    }

    if (filters.body_parts_conf) {
      for (const key in filters.body_parts_conf) {
        const value = filters.body_parts_conf[key];
        let condition;

        if (value.startsWith(">=")) {
          condition = `${key} : {_gte: "${value.slice(3)}" }`;
        } else if (value.startsWith("<=")) {
          condition = `${key} : {_lte: "${value.slice(3)}" }`;
        }

        bodyPartsConditions.push(condition);
      }
    }

    if (filters.Tag1) {
      if (filters.Tag1.tag_1_id_label) {
        bodyPartsConditions.push(
          `tag_1_id_label : {_eq: "${filters.Tag1.tag_1_id_label}"}`
        );
      }

      if (filters.Tag1.tag_1_id_conf) {
        let condition;
        if (filters.Tag1.tag_1_id_conf.startsWith(">= ")) {
          condition = `tag_1_id_conf: {_gte: "${filters.Tag1.tag_1_id_conf.slice(
            3
          )}"}`;
        } else if (filters.Tag1.tag_1_id_conf.startsWith("<= ")) {
          condition = `tag_1_id_conf: {_lte: "${filters.Tag1.tag_1_id_conf.slice(
            3
          )}"}`;
        }
        if (condition) {
          bodyPartsConditions.push(condition);
        }
      }
    }

    if (filters.Tag2) {
      if (filters.Tag2.tag_2_id_label) {
        bodyPartsConditions.push(
          `tag_2_id_label : {_eq: "${filters.Tag2.tag_2_id_label}"}`
        );
      }

      if (filters.Tag2.tag_2_id_conf) {
        let condition;
        if (filters.Tag2.tag_2_id_conf.startsWith(">= ")) {
          condition = `tag_2_id_conf: {_gte: "${filters.Tag2.tag_2_id_conf.slice(
            3
          )}"}`;
        } else if (filters.Tag2.tag_2_id_conf.startsWith("<= ")) {
          condition = `tag_2_id_conf: {_lte: "${filters.Tag2.tag_2_id_conf.slice(
            3
          )}"}`;
        }
        if (condition) {
          bodyPartsConditions.push(condition);
        }
      }
    }

    // Combine conditions for GraphQL query
    let combinedWhereClause = "";
    if (bodyPartsConditions.length > 0) {
      combinedWhereClause = `body_parts: {${bodyPartsConditions.join(", ")}}`;
      // Add to classLabel if it's part of a larger query
      classLabelConditions.push(combinedWhereClause);
    }
  }
  let pgiesWhereClause =
    whereClauses.length > 0
      ? `classifications: {_and: [${whereClauses.join(", ")}]}`
      : "";
  let classLabelWhereClause =
    classLabelConditions.length > 0
      ? `, ${classLabelConditions.join(", ")}`
      : "";
  let combinedWhereClause =
    pgiesWhereClause || classLabelWhereClause
      ? `{${pgiesWhereClause}${classLabelWhereClause}}`
      : "";

  let mediaType;
  if (videos) {
    mediaType = "VIDEO";
  } else {
    mediaType = "IMAGE";
  }

  query += combinedWhereClause
    ? `, where: {media_type: {_eq: ${mediaType}}, pgies: ${combinedWhereClause}}`
    : `, where: {media_type: {_eq: ${mediaType}}}`;

  if (videos) {
    query += `) {
        media_timestamp
        camera_id
        customer_id
        width
        uploaded_at
        ratio
        num_frames_inferred
        num_frames
        media_type
        media_timestamp_to_inference
        keypoint_type
        json_type
        inference_to_upload
        inference_start
        height
        inference_end
        fps
        `;
  } else {
    query += combinedWhereClause
      ? `) {
      media_timestamp
      camera_id
      customer_id
      width
      height
      pgies(where :${combinedWhereClause})`
      : `) {
        media_timestamp
        camera_id
        customer_id
        width
        height
        pgies`;
  }

  // query += `) {
  //   media_timestamp
  //   camera_id
  //   customer_id
  //   pgies : ${combinedWhereClause}`

  // if (whereClauses.length > 0) {
  //   query += `(where: {classifications: { _and: [${whereClauses.join(
  //     ", "
  //   )}] }})`;
  // }

  if (videos) {
    query += `
    }
  }`;
  } else {
    // let classificationFields = classificationArray
    //   .map((name) => `${name}`)
    //   .join("\n        ");
    query += `{
        bbox
        tracking_id
        body_parts {
          foot_1_bbox
          foot_1_conf
          foot_1_label
          foot_2_bbox
          foot_2_conf
          foot_2_label
          foot_3_bbox
          foot_3_conf
          foot_3_label
          foot_4_bbox
          foot_4_conf
          foot_4_label
          head_bbox
          head_conf
          head_label
          joint_1_bbox
          joint_1_conf
          joint_1_label
          joint_2_bbox
          joint_2_conf
          joint_2_label
          joint_3_bbox
          joint_3_conf
          joint_3_label
          joint_4_bbox
          joint_4_conf
          joint_4_label
          tag_1_bbox
          tag_1_colour_conf
          tag_1_colour_id
          tag_1_colour_label
          tag_1_conf
          tag_1_id_conf
          tag_1_id_label
          tag_1_label
          tag_2_bbox
          tag_2_colour_conf
          tag_2_colour_id
          tag_2_colour_label
          tag_2_conf
          tag_2_id_conf
          tag_2_id_label
          tag_2_label
          tail_bbox
          tail_conf
          tail_label
        }
        class_label
        class_conf
        classifications {
          species_label
          species_conf
          contraction_conf_2
          contraction_conf
          contraction_label
          contraction_label_2
          mounting_label_2
          mounting_conf_2
          chinrest_label_2
          chinrest_conf_2
          age_label
          age_conf
          activity_label
          activity_conf
          breed_label
          breed_conf
        }
      }
      analytics_predator {
        tracking_id
        species_label
        species_conf
        s3_uri
        media_type
        media_timestamp
        gpt_description
        gpt_check
        frame_num
        conf_check
        camera_id
        breed_label
        breed_conf
        bbox_y
        bbox_x
        bbox_w
        bbox
        bbox_h
      }
      analytics_estrus {
        camera_id
        bbox_x
        bbox_y
        bbox_w
        bbox_h
        class_conf
        class_label
        conf_check
        gpt_check
        gpt_description
        oo_bbox_h
        oo_bbox_w
        oo_bbox_x
        oo_bbox_y
        oo_tracking_id
        recent_sent_check
        s3_uri
        media_timestamp
        tracking_id
        species_label
        species_conf
        class_label_2
        class_conf_2
        customer {
          id
          first_name
          last_name
        }
      }
      analytics_calving {
        tracking_id
        tail_ratio
        tail_conf
        tail_bbox
        tail_area
        tag_2_label
        tag_2_id_label
        tag_2_id_conf
        tag_2_conf
        tag_2_colour_conf
        tag_2_colour_label
        tag_2_bbox
        tag_1_label
        tag_1_id_label
        tag_1_id_conf
        tag_1_conf
        tag_1_colour_label
        tag_1_colour_conf
        tag_1_bbox
        species_label
        species_conf
        s3_uri
        gpt_check
        contraction_label_2
        contraction_label
        contraction_conf_2
        contraction_conf
        calving_label
        calving_conf
        bbox
      }
    }
  }`;
  }
  return query;
};

const store = new Vuex.Store({
  modules: {
    auth: auth_module,
  },
  state: {
    usersChecked: ['ADMIN', 'BETA', 'CUSTOMER', 'DEMO', 'DEVELOPER', 'EARLY_ADOPTER', 'INVENTORY', 'PARTNER', 'RESEARCHER'],
    hasuraAdminSecret: null,
    authorized: false,
    user: null,
    user_ddb: "",
    currentTemp: "",
    loginError: "",
    signupError: "",
    latitude: "",
    longitude: "",
    coordinates: Object,
    button: Boolean,
    // loadedCattle: [],
    ddbGetData: [],
    camera_objects: [],
    camera_count: 0,
    doneFetching: false,
    staging_data: [],
    production_data: [],
    staging_cameras: [],
    production_cameras: [],
    staging_ranches: [],
    production_ranches: [],
    site_objects: [],
    cognito_users: [],
    customer_objects: [],
    jetson_objects: [],
    wifi_objects: [],
    owner_name_object: {},
    name_owner_object: {},
    customer_names: [],
    site_name_object: {},
    name_site_object: {},
    site_names: [],
    videos: [],
    events: [],
    selected_customer: {},
    edited_customer: {},
    animals: [],
    herds: [],
    footage: [],
    contacts: [],
    projects: [],
    camera_ids: [],
    selected_project_contacts: [],
    project_id_names: [],
    correspondences: [],
    all_correspondences: [],
    selected_projects: [],
    selected_contacts: [],
    contact_names: [],
    last_footage_upload_cameras: [],
    selected_camera: [],
    selected_notes: [],
    notes: [],
    feedbacks: [],
    treeview_customer: null,

    notifications: null,
    notification_count: 0,

    camera_models: [
      "E1 Outdoor",
      "RLC-511WA",
      "RLC-511W",
      "E1 Zoom",
      "RLC-811A",
      "Argus PT",
      "Reolink Go PT",
      "iPhone",
      "Duo Wifi",
      "RLC-523WA",
      "RLC-542WA",
      "Trackmix WIFI",
      "Trackmix POE",
      "823A",
    ],
    camera_sources: {},
    camera_resolutions: [],
    camera_shipping_status: [
      "DELIVERED",
      "INVENTORY",
      "DEVELOPMENT",
      "SHIPPED",
      "UNDEFINED",
    ],
    camera_online_status: ["ONLINE", "OFFLINE", "WARNING"],
    customer_status: ["ACTIVE", "INACTIVE", "DISABLED"],
    shipping_status: [
      "DELIVERED",
      "INVENTORY",
      "DEVELOPMENT",
      "SHIPPED",
      "UNDEFINED",
    ],
    online_status: ["ONLINE", "OFFLINE", "WARNING", "UNDEFINED"],
    wifi_models: [
      "AC_LITE",
      "AC_LITEBEAM",
      "AC_LITE_V6",
      "AC_LR",
      "AC_LR_V6",
      "AC_PRO",
      "GOOGLE_POINT",
      "H2D",
      "H2E",
      "H3E",
      "UNDEFINED",
    ],
    wifi_shipping_status: ["DELIVERED", "INVENTORY", "SHIPPED", "UNDEFINED"],
    wifi_online_status: ["ONLINE", "OFFLINE", "WARNING", "UNDEFINED"],
    wifi_manufacturers: ["EERO", "GOOGLE", "UBIQUITI"],
    jetson_online_status: [],
    jetson_shipping_status: [],

    customer_card_dialog: false,
    user_card_dialog: false,
    site_card_dialog: false,
    camera_card_dialog: false,
    nuke_card_dialog: false,
    wifi_card_dialog: false,
    jetson_card_dialog: false,
    collaboration_card_dialog: false,
    note_card_dialog: false,
    image_card_dialog: false,
    image_card_minimal_dialog: false,
    general_filter_dialog: false,

    provinces: [
      "AB",
      "BC",
      "MB",
      "NB",
      "NL",
      "NT",
      "NS",
      "NU",
      "ON",
      "PE",
      "QC",
      "SK",
      "YT",
    ],
    states: [
      "AL",
      "AK",
      "AS",
      "AZ",
      "AR",
      "CA",
      "CO",
      "CT",
      "DE",
      "DC",
      "FM",
      "FL",
      "GA",
      "GU",
      "HI",
      "ID",
      "IL",
      "IN",
      "IA",
      "KS",
      "KY",
      "LA",
      "ME",
      "MH",
      "MD",
      "MA",
      "MI",
      "MN",
      "MS",
      "MO",
      "MT",
      "NE",
      "NV",
      "NH",
      "NJ",
      "NM",
      "NY",
      "NC",
      "ND",
      "MP",
      "OH",
      "OK",
      "OR",
      "PW",
      "PA",
      "PR",
      "RI",
      "SC",
      "SD",
      "TN",
      "TX",
      "UT",
      "VT",
      "VI",
      "VA",
      "WA",
      "WV",
      "WI",
      "WY",
    ],
    jwt_token: null,

    customer_types: [
      "ADMIN",
      "BETA",
      "CUSTOMER",
      "EARLY_ADOPTER",
      "DEMO",
      "DEVELOPER",
      "INVENTORY",
      "PARTNER",
      "RESEARCHER",
      "USER",
    ],
    notification_levels: [],
    notification_frequency: [
      "NEVER",
      "FIVE_MINUTES",
      "FIFTEEN_MINUTES",
      "THIRTY_MINUTES",
      "ONE_HOUR",

      "TWO_HOURS",
      "FOUR_HOURS",
      "EIGHT_HOURS",
      "TWELVE_HOURS",
      "ONE_DAY",
    ],
    wait_interval: 2500,

    images: [],
    imagesImagePlayer: [],
    videosBoard: [],
    videosTable: [],
    videos_timestream: [],
    notification_fields: [
      {
        text: "Alert Call",
        value: "notification_preferences.alert_call_frequency",
      },
      {
        text: "Alert Email",
        value: "notification_preferences.alert_email_frequency",
      },
      {
        text: "Alert SMS",
        value: "notification_preferences.alert_sms_frequency",
      },
      {
        text: "Warning Call",
        value: "notification_preferences.warning_call_frequency",
      },
      {
        text: "Warning Email",
        value: "notification_preferences.warning_email_frequency",
      },
      {
        text: "Warning SMS",
        value: "notification_preferences.warning_sms_frequency",
      },
      {
        text: "Info Call",
        value: "notification_preferences.info_call_frequency",
      },
      {
        text: "Info Email",
        value: "notification_preferences.info_email_frequency",
      },
      {
        text: "Info SMS",
        value: "notification_preferences.info_sms_frequency",
      },
    ],
    bbox_color_code: {
      head: {
        fillStyle: "rgba(0, 154, 255, 0.4)",
        strokeStyle: "rgba(0, 154, 255)",
      },
      tag: {
        fillStyle: "rgba(55, 255, 255, 0.4)",
        strokeStyle: "rgba(55, 255, 255)",
      },
      tail: {
        fillStyle: "rgba(255, 66, 161, 0.4)",
        strokeStyle: "rgba(255, 66, 161)",
      },
      car: {
        fillStyle: "rgba(186, 86, 36, 0.4)",
        strokeStyle: "rgba(186, 86, 36)",
      },
      vehicle: {
        fillStyle: "rgba(186, 86, 36, 0.4)",
        strokeStyle: "rgba(186, 86, 36)",
      },
      cat: {
        fillStyle: "rgba(92, 103, 132, 0.4)",
        strokeStyle: "rgba(92, 103, 132)",
      },
      cow: {
        fillStyle: "rgba(242, 114, 0, 0.4)",
        strokeStyle: "rgba(242, 114, 0)",
      },
      dog: {
        fillStyle: "rgba(32, 164, 243, 0.4)",
        strokeStyle: "rgba(32, 164, 243)",
      },
      horse: {
        fillStyle: "rgba(148, 123, 211, 0.4)",
        strokeStyle: "rgba(148, 123, 211)",
      },
      person: {
        fillStyle: "rgba(240, 167, 160, 0.4)",
        strokeStyle: "rgba(240, 167, 160)",
      },
      pig: {
        fillStyle: "rgba(96, 73, 90, 0.4)",
        strokeStyle: "rgba(96, 73, 90)",
      },
      sheep: {
        fillStyle: "rgba(255, 87, 187, 0.4)",
        strokeStyle: "rgba(255, 87, 187)",
      },
      truck: {
        fillStyle: "rgba(140, 39, 30, 0.4)",
        strokeStyle: "rgba(140, 39, 30)",
      },
      coyote: {
        fillStyle: "rgba(247, 238, 127, 0.4)",
        strokeStyle: "rgba(247, 238, 127)",
      },
      canine: {
        fillStyle: "rgba(247, 238, 127, 0.4)",
        strokeStyle: "rgba(247, 238, 127)",
      },
      bear: {
        fillStyle: "rgba(164, 180, 148, 0.4)",
        strokeStyle: "rgba(164, 180, 148)",
      },
      bison: {
        fillStyle: "rgba(196, 167, 125, 0.4)",
        strokeStyle: "rgba(196, 167, 125)",
      },
    },
    PGIE_type_list: ["animal", "person", "vehicle"],
    Species_type_list: [
      "bison",
      "canine",
      "cat",
      "cow",
      "donkey",
      "elk",
      "horse",
      "llama",
      "null",
      "pig",
      "sheep",
      "goat",
    ],
    SGIE_type_list: ["head", "tail", "tag"],
    Vehicle_type_list: [
      "car",
      "motorcycle",
      "pick_up_truck",
      "quad",
      "semi_Truck",
      "tractor",
      "van",
    ],
    Vehicle_make_list: [
      "chevrolet",
      "honda",
      "hyundai",
      "jeep",
      "kia",
      "mazda",
      "nissan",
      "toyota",
      "ford",
      "ram",
      "null",
    ],
    Human_pose_list: ["riding", "squat", "standing"],
    model_version_list: [
      "nobj_timestamp",
      "pgie_yolox",
      "pgie_yolov8",
      "pgie_yolox_ensemble",
      "sgie_dog_activity",
      "sgie_cow_suckling",
      "sgie_keypoint_0_ensemble",
      "sgie_keypoint_0_ensemble_dog",
      "sgie_cow_body_part_ensemble",
      "sgie_cow_age",
      "sgie_contraction",
      "sgie_cow_contraction",
      "sgie_dog_body_part_ensemble",
      "sgie_cow_ocr",
      "sgie_cow_activity",
      "sgie_bbox_colour_tag",
      "sgie_body_parts",
      "sgie_cow_keypoints",
      "sgie_cow_mounting",
      "sgie_dog_breed",
      "sgie_license_plate_ocr",
      "sgie_dog_timeseries_scratching_ensemble",
      "sgie_keypoint_human_ensemble",
      "sgie_license_plates",
      "sgie_tag_colour",
      "sgie_vehicle_brand",
      "sgie_vehicle_type",
      "sgie_cow_delivery",
      "sgie_cow_chinrest",
      "sgie_cow_mounting_cross_tree",
      "sgie_species",
      "sgie_heat_detection",
    ],
    time_ranges: [
      { text: "Last 5 Minutes", value: "5m" },
      { text: "Last 10 Minutes", value: "10m" },
      { text: "Last 15 Minutes", value: "15m" },
      { text: "Last 30 Minutes", value: "30m" },
      { text: "Last 1 Hours", value: "1h" },
      { text: "Last 3 Hours", value: "3h" },
      { text: "Last 6 Hours", value: "6h" },
      { text: "Last 12 Hours", value: "12h" },
      { text: "Last 24 Hours", value: "24h" },
      { text: "Last 3 Days", value: "3d" },
      { text: "Last 7 Days", value: "7d" },
      { text: "Last 14 Days", value: "14d" },
      { text: "Last 28 Days", value: "28d" },
    ],
    time_settings: {
      "5m": {
        bucket: "1minute",
        from: "now-5m",
        to: "now",
        moment_args: [5, "minutes"],
      },
      "10m": {
        bucket: "1minute",
        from: "now-10m",
        to: "now",
        moment_args: [10, "minutes"],
      },
      "15m": {
        bucket: "1minute",
        from: "now-15m",
        to: "now",
        moment_args: [15, "minutes"],
      },
      "30m": {
        bucket: "5minute",
        from: "now-30m",
        to: "now",
        moment_args: [30, "minutes"],
      },
      "1h": {
        bucket: "5minute",
        from: "now-1h",
        to: "now",
        moment_args: [1, "hours"],
      },
      "3h": {
        bucket: "15minute",
        from: "now-3h",
        to: "now",
        moment_args: [3, "hours"],
      },
      "6h": {
        bucket: "1hour",
        from: "now-6h",
        to: "now",
        moment_args: [6, "hours"],
      },
      "12h": {
        bucket: "1hour",
        from: "now-12h",
        to: "now",
        moment_args: [12, "hours"],
      },
      "24h": {
        bucket: "1hour",
        from: "now-24h",
        to: "now",
        moment_args: [24, "hours"],
      },
      "3d": {
        bucket: "1day",
        from: "now-3d",
        to: "now",
        moment_args: [3, "days"],
      },
      "7d": {
        bucket: "1day",
        from: "now-7d",
        to: "now",
        moment_args: [7, "days"],
      },
      "14d": {
        bucket: "1day",
        from: "now-14d",
        to: "now",
        moment_args: [14, "days"],
      },
      "28d": {
        bucket: "1day",
        from: "now-28d",
        to: "now",
        moment_args: [28, "days"],
      },
    },
    current_customer: {},
    animal_tags: [],

    video_years: [2021, 2022, 2023],
    animal_images: [],
    animal_images_count: 0,
    triton_model_list: [
      "nobj_timestamp",
      "pgie_yolox",
      "sgie_body_parts",
      "sgie_cow_activity",
      "sgie_cow_age",
      "sgie_cow_chinrest",
      "sgie_cow_contraction",
      "sgie_cow_delivery",
      "sgie_cow_keypoints",
      "sgie_cow_keypoints_ensemble",
      "sgie_cow_keypoints_postprocess",
      "sgie_cow_mounting",
      "sgie_cow_ocr",
      "sgie_cow_suckling",
      "sgie_dog_activity",
      "sgie_dog_breed",
      "sgie_license_plate_ocr",
      "sgie_license_plates",
      "sgie_species",
      "sgie_tag_colour",
      "sgie_vehicle_type",
    ],
    triton_metric_list: [
      "nv_cache_hit_lookup_duration_per_model_total",
      "nv_cache_miss_insertion_duration_per_model_total",
      "nv_cache_miss_lookup_duration_per_model_total",
      "nv_cache_num_hits_per_model_total",
      "nv_cache_num_misses_per_model_total",
      "nv_inference_compute_infer_duration_us_total",
      "nv_inference_compute_input_duration_us_total",
      "nv_inference_compute_output_duration_us_total",
      "nv_inference_count_total",
      "nv_inference_exec_count_total",
      "nv_inference_queue_duration_us_total",
      "nv_inference_request_duration_us_total",
      "nv_inference_request_failure_total",
      "nv_inference_request_success_total",
    ],

    hasura_params: {
      url: "https://onecup-writer.hasura.app/v1/graphql",
      headers: {
        Authorizaation: "",
        "Content-Type": "application/json",
        "x-hasura-admin-secret": "",
      },
    },

    hasura_params_write: {
      url: "https://onecup-writer.hasura.app/v1/graphql",
      headers: {
        Authorizaation: "",
        "Content-Type": "application/json",
        "x-hasura-admin-secret": "",
      },
    },

    admin_key: null,

    selection_cameras: [],

    summary_media: [],
    summary_pgie: [],
    summary_activity: [],
    summary_calving: [],
    summary_estrus: [],
    summary_species: [],
    summary_vpc: [],
    summary_vehicle: [],
    summary_tag: [],

    home_page_stats: {
      customer_count: "...",
      site_count: "...",
      animal_count: "...",
      animal_tag_count: "...",
      animal_image_count: "...",
      camera_count: "...",
      online_camera_count: "...",
      wifi_count: "...",
    },

    analytics_calving: [],
    analytics_calving_count: 0,

    analytics_estrus: [],
    analytics_estrus_count: 0,

    analytics_predator: [],
    analytics_predator_count: 0,

    media_by_camera_summary: [],

    notification_analytics: { type: [], customer: [], sent: [] },

    calving_charts: { type: [], customer: [], sent: [] },
    estrus_charts: { type: [], customer: [], sent: [] },
    predator_charts: { type: [], customer: [], sent: [] },

    animal_id_charts: { type: [], customer: [] },
    animal_id_unique_charts: { combo: [], label: [], color: [] },

    animal_id_userdb: { total: [], pending: [], approved: [], denied: [] },

    by_camera: [],
  },

  mutations: {
    SET_USERS_CHECKED(state, value) {
      state.usersChecked = value;
    },
    SET_ANIMAL_ID_USERDB(state, payload) {
      state.animal_id_userdb = payload;
    },
    SET_ANIMAL_ID_UNIQUE_CHARTS(state, payload) {
      state.animal_id_unique_charts = payload;
    },
    SET_ANIMAL_ID_CHARTS(state, payload) {
      state.animal_id_charts = payload;
    },
    SET_CALVING_CHARTS(state, payload) {
      state.calving_charts = payload;
    },
    SET_ESTRUS_CHARTS(state, payload) {
      state.estrus_charts = payload;
    },
    SET_PREDATOR_CHARTS(state, payload) {
      state.predator_charts = payload;
    },
    SET_NOTIFICATION_ANALYTICS(state, payload) {
      state.notification_analytics = payload;
    },
    SET_MEDIA_BY_CAMERA_SUMMARY(state, payload) {
      state.media_by_camera_summary = payload;
    },
    SET_MODEL_VERSION_LIST(state, payload) {
      state.model_version_list = payload;
    },
    SET_ANIMAL_TAGS(state, payload) {
      state.animal_tags = payload;
    },
    SET_WIFI_MODELS(state, payload) {
      state.wifi_models = payload;
    },
    SET_CURRENT_CUSTOMER(state, payload) {
      state.current_customer = payload;
    },
    SET_IMAGES(state, payload) {
      state.images = payload;
    },
    SET_IMAGES_IMAGEPLAYER(state, payload) {
      state.imagesImagePlayer = payload;
    },
    SET_VIDEOS_TIMESTREAM(state, payload) {
      state.videos_timestream = payload;
    },
    SET_VIDEOS_VIDEOBOARD(state, payload) {
      state.videosBoard = payload;
    },
    SET_VIDEOS_VIDEOTABLE(state, payload) {
      state.videosTable = payload;
    },
    SET_CUSTOMER_TYPES(state, payload) {
      state.customer_types = payload;
    },
    SET_NOTIFICATION_LEVELS(state, payload) {
      state.notification_levels = payload;
    },
    SET_NOTIFICATION_FREQUENCY(state, payload) {
      state.notification_frequency = payload;
    },
    SET_JWT_TOKEN(state, payload) {
      state.jwt_token = payload;
    },
    SET_NOTE_CARD_DIALOG(state, payload) {
      state.note_card_dialog = payload;
    },
    SET_IMAGE_CARD_DIALOG(state, payload) {
      state.image_card_dialog = payload;
    },
    SET_IMAGE_CARD_MINIMAL_DIALOG(state, payload) {
      state.image_card_minimal_dialog = payload;
    },
    SET_GENERAL_FILTER_DIALOG(state, payload) {
      state.general_filter_dialog = payload;
    },
    SET_CUSTOMER_CARD_DIALOG(state, payload) {
      state.customer_card_dialog = payload;
    },
    SET_USER_CARD_DIALOG(state, payload) {
      state.user_card_dialog = payload;
    },
    SET_SITE_CARD_DIALOG(state, payload) {
      state.site_card_dialog = payload;
    },
    SET_CAMERA_CARD_DIALOG(state, payload) {
      state.camera_card_dialog = payload;
    },
    SET_NUKE_CARD_DIALOG(state, payload) {
      state.nuke_card_dialog = payload;
    },
    SET_WIFI_CARD_DIALOG(state, payload) {
      state.wifi_card_dialog = payload;
    },
    SET_JETSON_CARD_DIALOG(state, payload) {
      state.jetson_card_dialog = payload;
    },
    SET_COLLABORATION_CARD_DIALOG(state, payload) {
      state.collaboration_card_dialog = payload;
    },
    SET_TREEVIEW_CUSTOMER(state, payload) {
      state.treeview_customer = payload;
    },
    SET_FEEDBACKS(state, payload) {
      state.feedbacks = payload;
    },
    SET_NOTES(state, payload) {
      state.notes = payload;
    },
    SET_SELECTED_NOTES(state, payload) {
      state.selected_notes = payload;
    },
    SET_SELECTED_CAMERA(state, payload) {
      state.selected_camera = payload;
    },
    SET_LAST_FOOTAGE_UPLOAD_CAMERAS(state, payload) {
      state.last_footage_upload_cameras = payload;
    },
    SET_CONTACT_NAMES(state, payload) {
      state.contact_names = payload;
    },
    SET_SELECTED_CONTACTS(state, payload) {
      state.selected_contacts = payload;
    },
    SET_SELECTED_PROJECTS(state, payload) {
      state.selected_projects = payload;
    },
    SET_ALL_CORRESPONDENCES(state, payload) {
      state.all_correspondences = payload;
    },
    SET_CORRESPONDENCES(state, payload) {
      state.correspondences = payload;
    },
    SET_CAMERA_IDS(state, payload) {
      state.camera_ids = payload;
    },
    SET_CONTACTS(state, payload) {
      state.contacts = payload;
    },
    SET_HERDS(state, payload) {
      state.herds = payload;
    },
    SET_ANIMALS(state, payload) {
      state.animals = payload;
    },
    SET_SELECTED_CUSTOMER(state, payload) {
      state.selected_customer = payload;
    },
    SET_EDITED_CUSTOMER(state, payload) {
      state.edited_customer = payload;
    },
    SET_SITE_NAME_OBJECT(state, payload) {
      state.site_name_object = payload;
    },
    SET_NAME_SITE_OBJECT(state, payload) {
      state.name_site_object = payload;
    },
    SET_SITE_NAMES(state, payload) {
      state.site_names = payload;
    },
    SET_VIDEOS(state, payload) {
      state.videos = payload;
    },
    SET_EVENTS(state, payload) {
      state.events = payload;
    },
    SET_NOTIFICATIONS(state, payload) {
      state.notifications = payload.notifications;
      state.notification_count = payload.notification_count;
    },
    SET_OWNER_NAME_OBJECT(state, payload) {
      state.owner_name_object = payload;
    },
    SET_NAME_OWNER_OBJECT(state, payload) {
      state.name_owner_object = payload;
    },
    SET_CUSTOMER_NAMES(state, payload) {
      state.customer_names = payload;
    },
    SET_COORDINATES(state, payload) {
      state.coordinates = payload;
    },
    SET_PRODUCTION_DATA(state, payload) {
      state.production_data = payload;
    },
    SET_CAMERA_OBJECTS(state, payload) {
      state.camera_objects = payload.cameras;
      state.camera_count = payload.count;
    },
    SET_CAMERA_MODELS(state, payload) {
      state.camera_models = payload;
    },
    SET_CAMERA_RESOLUTIONS(state, payload) {
      state.camera_resolutions = payload;
    },
    SET_CAMERA_SOURCES(state, payload) {
      state.camera_sources = payload;
    },
    SET_CAMERA_SHIPPING_STATUS(state, payload) {
      state.camera_shipping_status = payload;
    },
    SET_CAMERA_ONLINE_STATUS(state, payload) {
      state.camera_online_status = payload;
    },
    SET_WIFI_SHIPPING_STATUS(state, payload) {
      state.wifi_shipping_status = payload;
    },
    SET_WIFI_ONLINE_STATUS(state, payload) {
      state.wifi_online_status = payload;
    },
    SET_WIFI_MANUFACTURERS(state, payload) {
      state.wifi_manufacturers = payload;
    },
    SET_JETSON_ONLINE_STATUS(state, payload) {
      state.jetson_online_status = payload;
    },
    SET_JETSON_SHIPPING_STATUS(state, payload) {
      state.jetson_shipping_status = payload;
    },
    SET_CUSTOMER_STATUS(state, payload) {
      state.customer_status = payload;
    },
    SET_PRODUCTION_CAMERAS(state, payload) {
      state.production_cameras = payload;
    },
    SET_STAGING_RANCHES(state, payload) {
      state.staging_ranches = payload;
    },
    SET_SITE_OBJECTS(state, payload) {
      state.site_objects = payload;
    },
    SET_PRODUCTION_RANCHES(state, payload) {
      state.production_ranches = payload;
    },
    SET_THUMBNAILS(state, payload) {
      state.thumbnails = payload;
    },
    SET_COGNITO_USERS(state, payload) {
      state.cognito_users = payload;
    },
    SET_CUSTOMER_OBJECTS(state, payload) {
      state.customer_objects = payload;
    },
    SET_JETSON_OBJECTS(state, payload) {
      state.jetson_objects = payload;
    },
    SET_WIFI_OBJECTS(state, payload) {
      state.wifi_objects = payload;
    },
    SET_FOOTAGE(state, payload) {
      state.footage = payload;
    },
    SET_PROJECTS(state, payload) {
      state.projects = payload;
    },
    SET_SELECTED_PROJECT_CONTACTS(state, payload) {
      state.selected_project_contacts = payload;
    },
    SET_PROJECT_ID_NAMES(state, payload) {
      state.project_id_names = payload;
    },
    SET_HASURA_ADMIN_KEY(state, payload) {
      state.admin_key = payload;
    },
    SET_SELECTION_CAMERAS(state, payload) {
      state.selection_cameras = payload;
    },
    SET_ANIMAL_IMAGES(state, payload) {
      state.animal_images = payload.animal_images;
      state.animal_images_count = payload.animal_images_count;
    },
    SET_SUMMARY_MEDIA(state, payload) {
      state.summary_media = payload;
    },
    SET_SUMMARY_PGIE(state, payload) {
      state.summary_pgie = payload;
    },
    SET_SUMMARY_ACTIVITY(state, payload) {
      state.summary_activity = payload;
    },
    SET_SUMMARY_CALVING(state, payload) {
      state.summary_calving = payload;
    },
    SET_SUMMARY_ESTRUS(state, payload) {
      state.summary_estrus = payload;
    },
    SET_SUMMARY_SPECIES(state, payload) {
      state.summary_species = payload;
    },
    SET_SUMMARY_VPC(state, payload) {
      state.summary_vpc = payload;
    },
    SET_SUMMARY_VEHICLE(state, payload) {
      state.summary_vehicle = payload;
    },
    SET_SUMMARY_TAG(state, payload) {
      state.summary_tag = payload;
    },
    SET_HOME_PAGE_STATS(state, payload) {
      state.home_page_stats = payload;
    },
    SET_ANALYTICS_CALVING(state, payload) {
      state.analytics_calving = payload.analytics_calving;
      state.analytics_calving_count = payload.analytics_calving_count;
    },
    SET_ANALYTICS_ESTRUS(state, payload) {
      state.analytics_estrus = payload.analytics_estrus;
      state.analytics_estrus_count = payload.analytics_estrus_count;
    },
    SET_ANALYTICS_PREDATOR(state, payload) {
      state.analytics_predator = payload.analytics_predator;
      state.analytics_predator_count = payload.analytics_predator_count;
    },
    SET_BY_CAMERA(state, payload) {
      state.by_camera = payload;
    },
    user(state, user) {
      // state.authorized = !!user && user.attributes && user.attributes.email_verified
      state.authorized = !!user && user.attributes;
      state.user = user;
    },
    NULL() {
      return null;
    },
  },

  actions: {
    /**
     *
     * @param {Object} params
     * @param {Array} params.date_range Date range
     * @param {Number} params.limit Limit
     * @param {Boolean} params.first_time Is first time?
     * @param {String} params.user_id user id
     * @param {String} params.camera_id camera id
     *
     * @param {Object} params.model_versions model versions
     * @param {Object} params.model_versions.sgie_contraction sgie_contraction
     *
     * @param {Object} params.filters
     * @param {Object} params.filters.PGIE PGIE classifications
     * @param {Object} params.filters.Species Species classifications
     * @param {Object} params.filters.SGIE SGIE classifications
     * @param {Object} params.filters.OCR OCR IDs
     * @param {Object} params.filters.Contraction Contraction classifications
     * @param {Object} params.filters.Contraction_Classification New contraction classifications
     * @param {Object} params.filters.Suckling Suckling classifications
     * @param {Object} params.filters.Activity Activity classifications
     * @param {Object} params.filters.Age Age classifications
     * @returns Promise
     */

    DDB_GET_CUSTOMERS({ commit, rootGetters }) {
      new Promise((resolve) => {
        async function get_customers() {
          const hasura_params = rootGetters["auth/hasura_params"]
          var customer_objects = (
            await axios.post(
              hasura_params.url,
              {
                query: hasura_queries.customer,

              },
              {
                headers: hasura_params.headers,
              }
            )
          ).data.data.customer;

          var customer_names = [[], {}];
          for (const i in customer_objects) {
            customer_names[0].push({
              text:
                (customer_objects[i].first_name
                  ? customer_objects[i].first_name + " "
                  : "") + customer_objects[i].last_name,
              value: customer_objects[i].id,
            });
            customer_names[1][customer_objects[i].id] = [];
            for (const n in customer_objects[i].sites) {
              customer_names[1][customer_objects[i].id].push({
                text: customer_objects[i].sites[n].name,
                value: customer_objects[i].sites[n].id,
              });
            }
          }

          commit("SET_CUSTOMER_NAMES", customer_names);
          commit("SET_CUSTOMER_OBJECTS", customer_objects);

          resolve();
        }
        get_customers();
      });
    },

    DDB_GET_SELECTED_NOTES({ commit, rootGetters }, params) {
      return new Promise((resolve) => {
        async function get_notes() {
          const hasura_params = rootGetters["auth/hasura_params"]
          let where = {};
          where[params.type + "_id"] = { _eq: params.id };

          let notes = await axios.post(
            hasura_params.url,
            {
              query: hasura_queries.admin_note,
              variables: {
                where: where,
              },
            },
            {
              headers: hasura_params.headers,
            }
          );
          commit("SET_SELECTED_NOTES", notes.data.data.admin_note);
          resolve();
        }
        get_notes();
      });
    },

    DDB_GET_SITES({ commit, rootGetters }) {

      sem_status.sites = new Promise((resolve) => {
        async function get_sites() {
          const hasura_params = rootGetters["auth/hasura_params"]

          var site_objects = (
            await axios.post(
              hasura_params.url,
              {
                query: hasura_queries.site,
              },
              {
                headers: hasura_params.headers,
              }
            )
          ).data.data.site;
          console.log("site_objects", site_objects);
          var site_name_object = {};
          var name_site_object = {};
          var site_names = [];
          for (const i in site_objects) {
            site_names.push(site_objects[i].name);
            site_name_object[site_objects[i].id] = site_objects[i].name;
            name_site_object[site_objects[i].name] = site_objects[i].id;
          }
          site_names.sort();
          commit("SET_SITE_NAMES", site_names);
          commit("SET_SITE_NAME_OBJECT", site_name_object);
          commit("SET_NAME_SITE_OBJECT", name_site_object);
          commit("SET_SITE_OBJECTS", site_objects);
          resolve();
        }
        get_sites();
      });
    },
    DDB_GET_CAMERAS({ commit, rootGetters }, params) {
      if (sem_status.cameras) {
        return sem_status.cameras;
      }
      sem_status.cameras = new Promise((resolve) => {
        async function get_cameras() {
          const hasura_params = rootGetters["auth/hasura_params"]

          let order_by = {};
          if (params.sort) {
            order_by[params.sort] = params.sort_direction;
          }
          let where = {};

          if (params.search && params.search.length) {
            where._or = [
              { name: { _iregex: params.search } },
              { id: { _iregex: params.search } },
            ];
          }
          if (
            params.filter.customer &&
            params.filter.customer != "All Customers"
          ) {
            where.customer_id = { _eq: params.filter.customer };
          }
          if (params.filter.status && params.filter.status != "All") {
            where.status = { _eq: params.filter.status };
          }
          if (params.filter.model && params.filter.model != "All") {
            where.model = { _eq: params.filter.model };
          }
          if (
            params.filter.blurriness_label &&
            params.filter.blurriness_label != "All"
          ) {
            where.blurriness_label = { _eq: params.filter.blurriness_label };
          }
          if (params.filter.shipped && params.filter.shipped != "All") {
            where.shipped = { _eq: params.filter.shipped };
          }

          var camera_objects = (
            await axios.post(
              hasura_params.url,
              {
                query: hasura_queries.camera,
                variables: {
                  where: where,
                  order_by: order_by,
                  limit: params.limit,
                  offset: params.offset,
                },
              },
              {
                headers: hasura_params.headers,
              }
            )
          ).data;
          var count = (
            await axios.post(
              hasura_params.url,
              {
                query: hasura_queries.camera_aggregate,
                variables: {
                  where: where,
                },
              },
              {
                headers: hasura_params.headers,
              }
            )
          ).data.data;
          // console.log(camera_objects);
          // console.log(where);
          commit("SET_CAMERA_OBJECTS", {
            cameras: camera_objects.data.camera,
            count: count.camera_aggregate.aggregate.count,
          });
          delete sem_status.cameras;
          resolve();
        }

        get_cameras();
      });
      return sem_status.cameras;
    },

    DDB_GET_WIFI({ commit, rootGetters }) {
      const hasura_params = rootGetters["auth/hasura_params"]

      sem_status.wifi = new Promise((resolve) => {
        async function get_wifi() {
          var wifi_objects = (
            await axios.post(
              hasura_params.url,
              {
                query: hasura_queries.wifi,
              },
              {
                headers: hasura_params.headers,
              }
            )
          ).data.data.wifi;
          commit("SET_WIFI_OBJECTS", wifi_objects);
          delete sem_status.wifi;
          resolve();
        }
        get_wifi();
      });
      return sem_status.wifi;
    },
    DDB_GET_VIDEOS_VIDEOTABLE({ commit, rootGetters }, params) {
      return new Promise((resolve, reject) => {

        async function getVideos() {
          const hasura_params = rootGetters["auth/hasura_params"]

          //  console.log(hasura_queries.inference_media_video)
          //  console.log(params.order_by)
          console.log(params)
          const response = await axios.post(
            hasura_params.url,
            {
              query: hasura_queries.inference_media_video,
              variables: {
                where: params.where,
                order_by: params.order_by,
                limit: params.limit,
                offset: params.offset,
              },
            },
            { headers: hasura_params.headers }
          );

          const response2 = await axios.post(
            hasura_params.url,
            {
              query: hasura_queries.inference_media_aggregate,
              variables: {
                where: params.where,
                order_by: params.order_by,
              },
            },
            { headers: hasura_params.headers }
          );
          console.log(response, response2);
          //DEBUG
          //   const whereString = JSON.stringify(params.where).replace(/"([^"]+)":/g, '$1:');

          // console.log(whereString)

          if (response) {
            var videos = [];
            var videos_list = response.data.data.inference_media.map(
              (video) => {
                var user_id = video.customer_id;
                var camera_id = video.camera_id;
                var video_time = moment(video.media_timestamp);

                var year = String(video_time.year()).padStart(4, "0");
                var month = String(video_time.month() + 1).padStart(2, "0");
                var day = String(video_time.date()).padStart(2, "0");
                var full_date = video_time.format("YYYY-MM-DD_HH-mm-ss");

                return {
                  ...video,
                  video_time: video_time.format("YYYY-MM-DD HH:mm:ss"),
                  video_path: `${user_id}/${camera_id}/${year}/${month}/${day}/${camera_id}_${full_date}`,
                };
              }
            );

            videos.push(videos_list);
            videos.push(
              response2.data.data.inference_media_aggregate.aggregate.count
            );
            commit("SET_VIDEOS_VIDEOTABLE", videos);

            resolve();
          } else {
            reject();
          }
        }
        getVideos();
      });
    },
       DDB_GET_SELECTION_CAMERAS({ commit, rootGetters }, params) {
      return new Promise((resolve) => {
        async function get_selection_cameras(params) {
          const hasura_params = rootGetters["auth/hasura_params"]
          let where = {};
          if (params.customer_id != "All Customers") {
            where.customer_id = { _eq: params.customer_id };
          }
          if (params.search && params.search != "All Cameras") {
            //where.name = { _iregex: params.search };
            where._or = [
              { name: { _iregex: params.search } },
              { id: { _iregex: params.search } },
            ];
          }
          //  console.log(where);
          let cameras = (
            await axios.post(
              hasura_params.url,
              {
                query: hasura_queries.camera,
                variables: {
                  where: where,
                  order_by: { name: "asc" },
                  limit: 12,
                },
              },
              {
                headers: hasura_params.headers,
              }
            )
          ).data;
          commit("SET_SELECTION_CAMERAS", cameras.data.camera);
          resolve();
        }
        get_selection_cameras(params);
      });
    },
    DDB_GET_IMAGES({ commit, state, rootGetters }, params) {
      const hasura_params = rootGetters["auth/hasura_params"]
      let estrusFilterApplied = Object.keys(params.filters.estrus).length > 0;
      let query = estrusFilterApplied
        ? buildEstrusQuery(params.filters)
        : buildQuery(params.filters);

      let isFilterApplied = false;

      if (params.user_id) {
        const customerIdFilter = `customer_id: {_eq: "${params.user_id}"}, `;
        const whereIndex = query.indexOf("where: {") + "where: {".length;
        const newQuery =
          query.slice(0, whereIndex) +
          customerIdFilter +
          query.slice(whereIndex);
        query = newQuery;
      }

      if (params.camera_id) {
        const cameraIdFilter = `camera_id: {_eq: "${params.camera_id}"}, `;
        const whereIndex = query.indexOf("where: {") + "where: {".length;
        const newQuery =
          query.slice(0, whereIndex) + cameraIdFilter + query.slice(whereIndex);
        query = newQuery;
      }

      if (params.date_range && params.date_range.length > 0) {
        let timestampFilter;
        const whereIndex = query.indexOf("where: {") + "where: {".length;

        const hourStart = params.filters.Time.hour_start;
        const hourEnd = params.filters.Time.hour_end;

        if (params.date_range.length === 1) {
          let dateStart = hourStart
            ? moment(params.date_range[0]).format(
              `YYYY-MM-DDT${hourStart}:00:00`
            )
            : moment(params.date_range[0]).format("YYYY-MM-DDT00:00:00");
          let dateEnd = hourEnd
            ? moment(params.date_range[0]).format(`YYYY-MM-DDT${hourEnd}:00:00`)
            : moment(params.date_range[0]).format("YYYY-MM-DDT23:59:59");

          timestampFilter = `media_timestamp: {_gte: "${dateStart}", _lte: "${dateEnd}"}, `;
        } else if (params.date_range.length === 2) {
          let dateStart = moment(params.date_range[0]).format("YYYY-MM-DD");
          let dateEnd = moment(params.date_range[1]).format("YYYY-MM-DD");

          dateStart += hourStart ? `T${hourStart}:00:00` : "T00:00:00";
          dateEnd += hourEnd ? `T${hourEnd}:00:00` : "T23:59:59";

          timestampFilter = `media_timestamp: {_gte: "${dateStart}", _lte: "${dateEnd}"}, `;
        }

        query =
          query.slice(0, whereIndex) +
          timestampFilter +
          query.slice(whereIndex);

        //const pgiesWithParenIndex = query.lastIndexOf("pgies(");
        const pgiesCurlyIndex = query.lastIndexOf("pgies{");

        if (pgiesCurlyIndex !== -1) {
          let index = pgiesCurlyIndex + 5;
          query =
            query.substring(0, index) +
            `(where : { ${timestampFilter}}){` +
            query.substring(index + 1);
        } else {
          let lastWhereIndex = query.lastIndexOf("where :{");
          if (lastWhereIndex !== -1) {
            let insertIndex = lastWhereIndex + 8;
            query =
              query.substring(0, insertIndex) +
              timestampFilter.substring(0, timestampFilter.length - 1) +
              query.substring(insertIndex);
          }
        }
      }
      // console.log(query);
      return new Promise((resolve, reject) => {
        async function getImages() {
          if (
            sem_status.limit &&
            params.limit &&
            sem_status.limit !== params.limit
          ) {
            // Calculate new offset based on the total number of images fetched and new limit
            var totalFetchedImages =
              state.images.length > 0 ? state.images[0].length : 0;
            var pagesFetched = Math.floor(totalFetchedImages / params.limit);
            sem_status.offset = pagesFetched * params.limit;
            sem_status.limit = params.limit;
          } else if (!sem_status.limit && params.limit) {
            // Initialize limit and offset if not already set
            sem_status.limit = params.limit;
            sem_status.offset = 0;
          }

          if (sem_status.query !== query) {
            isFilterApplied = true;
          }
          sem_status.query = query;

          if (isFilterApplied) {
            sem_status.offset = 0;
          }
          var variables = {
            limit: sem_status.limit + 1,
            offset: sem_status.offset,
          };

          //  console.log(query);
          //  console.log(variables)
          const response = await axios.post(
            hasura_params.url,
            { query: query, variables: variables },
            { headers: hasura_params.headers }
          );
          // console.log(response.data)
          console.log(response);
          var images = estrusFilterApplied
            ? response.data.data.analytics_estrus
            : response.data.data.inference_media;

          var hasNextPage = images.length > sem_status.limit;

          if (hasNextPage) {
            images.pop(); // remove the extra item
            sem_status.offset += sem_status.limit; // update offset for next page
          }
          var image_list;
          // console.log(images)
          if (estrusFilterApplied) {
            image_list = images.map((image) => {
              let user_id = image.customer ? image.customer.id : "";
              let camera_id = image.camera_id;
              let image_time = moment(image.media_timestamp);
              let bbox_list = [];
              if (
                image.bbox_x &&
                image.bbox_y &&
                image.bbox_w &&
                image.bbox_h
              ) {
                bbox_list.push({
                  x1: image.bbox_x,
                  y1: image.bbox_y,
                  w: image.bbox_w,
                  h: image.bbox_h,
                  tracking_id: image.tracking_id,
                  species: image.species_label,
                  speciesConf: image.species_conf,
                });
              }

              if (
                image.oo_bbox_x &&
                image.oo_bbox_y &&
                image.oo_bbox_w &&
                image.oo_bbox_h
              ) {
                bbox_list.push({
                  x1: image.oo_bbox_x,
                  y1: image.oo_bbox_y,
                  w: image.oo_bbox_w,
                  h: image.oo_bbox_h,
                  tracking_id: image.oo_tracking_id,
                });
              }

              if (bbox_list.length >= 2) {
                const minX = Math.min(...bbox_list.map((bbox) => bbox.x1));
                const minY = Math.min(...bbox_list.map((bbox) => bbox.y1));
                const maxX = Math.max(
                  ...bbox_list.map((bbox) => bbox.x1 + bbox.w)
                );
                const maxY = Math.max(
                  ...bbox_list.map((bbox) => bbox.y1 + bbox.h)
                );

                const encompassingWidth = maxX - minX;
                const encompassingHeight = maxY - minY;

                bbox_list.push({
                  x1: minX,
                  y1: minY,
                  w: encompassingWidth,
                  h: encompassingHeight,
                });
              }
              let classificationInfo =
                image.class_label !== undefined &&
                  image.class_conf !== undefined &&
                  image.class_label_2 !== undefined &&
                  image.class_conf_2 !== undefined
                  ? [
                    {
                      label1: image.class_label,
                      conf1: image.class_conf,
                      label2: image.class_label_2,
                      conf2: image.class_conf_2,
                    },
                  ]
                  : undefined;
              return {
                ...image,
                estrusFilterApplied: true,
                user_id: user_id,
                camera_id: camera_id,
                image_time: image_time.format("YYYY-MM-DD HH:mm:ss"),
                image_path: image.s3_uri,
                hasura_header: hasura_params.headers,
                hasura_url: hasura_params.url,
                bbox_list: bbox_list,
                classificationInfo: classificationInfo,
              };
            });
          } else {
            image_list = images.map((image) => {
              let user_id = image.customer_id;
              let camera_id = image.camera_id;
              let image_time = moment(image.media_timestamp);
              let bbox_list = [];
              let body_parts_list = [];
              let year = String(image_time.year()).padStart(4, "0");
              let month = String(image_time.month() + 1).padStart(2, "0");
              let day = String(image_time.date()).padStart(2, "0");
              let full_date = image_time.format("YYYY-MM-DD_HH-mm-ss");
              let tags = [];

              let analytics_calving = image.analytics_calving;
              let analytics_predator = image.analytics_predator;
              let analytics_estrus = image.analytics_estrus;

              image.pgies.map((inference) => {
                bbox_list.push({
                  x1: inference.bbox.x,
                  y1: inference.bbox.y,
                  w:
                    inference.bbox.width !== undefined
                      ? inference.bbox.width
                      : inference.bbox.w,
                  h:
                    inference.bbox.height !== undefined
                      ? inference.bbox.height
                      : inference.bbox.h,
                  type:
                    inference.classifications &&
                      inference.classifications.species_label
                      ? inference.classifications.species_label
                      : inference.class_label,
                });

                if (inference.body_parts) {
                  const partsToCheck = [
                    "head",
                    "tail",
                    "foot_1",
                    "foot_2",
                    "foot_3",
                    "foot_4",
                    "joint_1",
                    "joint_2",
                    "joint_3",
                    "joint_4",
                    "tag_1",
                    "tag_2",
                  ];

                  partsToCheck.forEach((p) => {
                    const bboxKey = `${p}_bbox`;
                    const confKey = `${p}_conf`;
                    const labelKey = `${p}_label`;

                    if (inference.body_parts[bboxKey] !== null) {
                      const conf = inference.body_parts[confKey];
                      const label = inference.body_parts[labelKey];

                      if (label == "tag") {
                        let tag_id = inference.body_parts[`${p}_id_label`];
                        let tag_id_conf = inference.body_parts[`${p}_id_conf`];
                        let tag_color =
                          inference.body_parts[`${p}_colour_label`];

                        if (tag_id_conf && tag_id_conf >= 0.7) {
                          body_parts_list.push({
                            bbox: inference.body_parts[bboxKey],
                            conf,
                            label,
                            tag_id: tag_id,
                            tag_id_conf: tag_id_conf,
                            tag_color,
                            tracking_id: inference.tracking_id,
                          });
                          tags.push({
                            tag_label: tag_id,
                            tracking_id: inference.tracking_id,
                            tag_color: tag_color,
                            tag_id_conf: tag_id_conf,
                          });
                        }
                      } else {
                        body_parts_list.push({
                          bbox: inference.body_parts[bboxKey],
                          conf,
                          label,
                          tracking_id: inference.tracking_id,
                        });
                      }
                    }
                  });
                }
              });
              return {
                ...image,
                estrusFilterApplied: false,
                inference: true,
                analytics_calving: analytics_calving,
                analytics_predator: analytics_predator,
                analytics_estrus: analytics_estrus,
                user_id: user_id,
                camera_id: camera_id,
                image_time: image_time.format("YYYY-MM-DD HH:mm:ss"),
                image_path: `${user_id}/${camera_id}/${year}/${month}/${day}/${camera_id}_${full_date}`,
                body_parts_list: body_parts_list,
                tags: tags,
                hasura_header: hasura_params.headers,
                hasura_url: hasura_params.url,
                bbox_list: bbox_list,
              };
            });
          }

          if (response) {
            if (params.first_time) {
              image_list = [image_list, sem_status.offset, image_list.length];
              commit("SET_IMAGES", image_list);
              commit("SET_IMAGES_IMAGEPLAYER", image_list);
            } else {
              if (params.imagePlayer) {
                image_list = updateImageList(
                  state.imagesImagePlayer,
                  image_list,
                  sem_status.offset
                );
                commit("SET_IMAGES_IMAGEPLAYER", image_list);
              } else {
                image_list = updateImageList(
                  state.images,
                  image_list,
                  sem_status.offset
                );
                commit("SET_IMAGES", image_list);
                if (
                  state.imagesImagePlayer[0].length < state.images[0].length
                ) {
                  commit("SET_IMAGES_IMAGEPLAYER", image_list);
                }
              }
            }
            resolve(hasNextPage);
          } else {
            reject();
          }
        }

        getImages();
      });
    },

    DDB_GET_VIDEOS_VIDEOBOARD({ commit, state }, params) {
      let query = buildQuery(params.filters, "VIDEO");
      let isFilterApplied = false;

      if (params.user_id) {
        const customerIdFilter = `customer_id: {_eq: "${params.user_id}"}, `;
        const whereIndex = query.indexOf("where: {") + "where: {".length;
        const newQuery =
          query.slice(0, whereIndex) +
          customerIdFilter +
          query.slice(whereIndex);
        query = newQuery;
      }

      if (params.camera_id) {
        const cameraIdFilter = `camera_id: {_eq: "${params.camera_id}"}, `;
        const whereIndex = query.indexOf("where: {") + "where: {".length;
        const newQuery =
          query.slice(0, whereIndex) + cameraIdFilter + query.slice(whereIndex);
        query = newQuery;
      }

      if (params.date_range && params.date_range.length > 0) {
        let timestampFilter;
        const whereIndex = query.indexOf("where: {") + "where: {".length;

        const hourStart = params.filters.Time.hour_start;
        const hourEnd = params.filters.Time.hour_end;

        if (params.date_range.length === 1) {
          let dateStart = hourStart
            ? moment(params.date_range[0]).format(
              `YYYY-MM-DDT${hourStart}:00:00`
            )
            : moment(params.date_range[0]).format("YYYY-MM-DDT00:00:00");
          let dateEnd = hourEnd
            ? moment(params.date_range[0]).format(`YYYY-MM-DDT${hourEnd}:00:00`)
            : moment(params.date_range[0]).format("YYYY-MM-DDT23:59:59");

          timestampFilter = `media_timestamp: {_gte: "${dateStart}", _lte: "${dateEnd}"}, `;
        } else if (params.date_range.length === 2) {
          let dateStart = moment(params.date_range[0]).format("YYYY-MM-DD");
          let dateEnd = moment(params.date_range[1]).format("YYYY-MM-DD");

          dateStart += hourStart ? `T${hourStart}:00:00` : "T00:00:00";
          dateEnd += hourEnd ? `T${hourEnd}:00:00` : "T23:59:59";

          timestampFilter = `media_timestamp: {_gte: "${dateStart}", _lte: "${dateEnd}"}, `;
        }

        query =
          query.slice(0, whereIndex) +
          timestampFilter +
          query.slice(whereIndex);

        //const pgiesWithParenIndex = query.lastIndexOf("pgies(");
        const pgiesCurlyIndex = query.lastIndexOf("pgies{");

        if (pgiesCurlyIndex !== -1) {
          let index = pgiesCurlyIndex + 5;
          query =
            query.substring(0, index) +
            `(where : { ${timestampFilter}}){` +
            query.substring(index + 1);
        } else {
          let lastWhereIndex = query.lastIndexOf("where :{");
          if (lastWhereIndex !== -1) {
            let insertIndex = lastWhereIndex + 8;
            query =
              query.substring(0, insertIndex) +
              timestampFilter.substring(0, timestampFilter.length - 1) +
              query.substring(insertIndex);
          }
        }
      }

      return new Promise((resolve, reject) => {
        async function getVideos() {
          if (
            sem_status.videos_limit &&
            params.limit &&
            sem_status.videos_limit !== params.limit
          ) {
            // Calculate new offset based on the total number of images fetched and new limit
            var totalFetchedVideos =
              state.videosBoard.length > 0 ? state.videosBoard[0].length : 0;
            var pagesFetched = Math.floor(totalFetchedVideos / params.limit);
            sem_status.videos_offset = pagesFetched * params.limit;
            sem_status.videos_limit = params.limit;
          } else if (!sem_status.videos_limit && params.limit) {
            // Initialize limit and offset if not already set
            sem_status.videos_limit = params.limit;
            sem_status.videos_offset = 0;
          }

          if (sem_status.videos_query !== query) {
            isFilterApplied = true;
          }
          sem_status.videos_query = query;

          if (isFilterApplied) {
            sem_status.videos_offset = 0;
          }
          var variables = {
            limit: sem_status.videos_limit + 1,
            offset: sem_status.videos_offset,
          };

          //console.log(query);
          const response = await axios.post(
            store.state.hasura_params.url,
            { query: query, variables: variables },
            { headers: store.state.hasura_params.headers }
          );

          var videos = response.data.data.inference_media;

          var hasNextPage = videos.length > sem_status.videos_limit;

          if (hasNextPage) {
            videos.pop(); // remove the extra item
            sem_status.videos_offset += sem_status.videos_limit; // update offset for next page
          }

          var videos_list = videos.map((video) => {
            var user_id = video.customer_id;
            var camera_id = video.camera_id;
            var video_time = moment(video.media_timestamp);

            var year = String(video_time.year()).padStart(4, "0");
            var month = String(video_time.month() + 1).padStart(2, "0");
            var day = String(video_time.date()).padStart(2, "0");
            var full_date = video_time.format("YYYY-MM-DD_HH-mm-ss");

            return {
              ...video,
              video_time: video_time.format("YYYY-MM-DD HH:mm:ss"),
              video_path: `${user_id}/${camera_id}/${year}/${month}/${day}/${camera_id}_${full_date}`,
            };
          });
          if (response) {
            if (params.first_time) {
              videos_list = [
                videos_list,
                sem_status.videos_offset,
                videos_list.length,
              ];
              commit("SET_VIDEOS_VIDEOBOARD", videos_list);
              // commit("SET_IMAGES_IMAGEPLAYER", image_list);
            } else {
              videos_list = updateVideoList(
                state.videosBoard,
                videos_list,
                sem_status.videos_offset
              );
              commit("SET_VIDEOS_VIDEOBOARD", videos_list);
            }

            resolve(hasNextPage);
          } else {
            reject();
          }
        }
        getVideos();
      });
    },
    /**
     *
     * @param {Object} params
     * @param {Array} params.date_range Date range
     * @param {Number} params.limit Limit
     * @param {Boolean} params.first_time Is first time?
     * @param {String} params.user_id user id
     * @param {String} params.camera_id camera id
     *
     * @param {Object} params.model_versions model versions
     * @param {Object} params.model_versions.sgie_contraction sgie_contraction
     *
     * @param {Object} params.filters
     * @param {Object} params.filters.PGIE PGIE classifications
     * @param {Object} params.filters.Species Species classifications
     * @param {Object} params.filters.SGIE SGIE classifications
     * @param {Object} params.filters.OCR OCR IDs
     * @param {Object} params.filters.Contraction Contraction classifications
     * @param {Object} params.filters.Contraction_Classification New contraction classifications
     * @param {Object} params.filters.Suckling Suckling classifications
     * @param {Object} params.filters.Activity Activity classifications
     * @param {Object} params.filters.Age Age classifications
     * @returns Promise
     */
    /**
     *
     * @param {Object} params
     * @param {String} params.search_str
     * @param {String} params.camera
     * @param {String} params.type
     * @param {String} params.customer
     * @param {String} params.level
     * @param {String} params.date
     * @returns
     */
    DDB_GET_NOTIFICATIONS({ commit }, params) {
      return new Promise((resolve) => {
        var _this = this;
        async function get_events(params) {
          _this.state.event_params = params;

          let order_by = {};
          if (params.sort) {
            order_by[params.sort] = params.sort_direction;
          }
          let where = {};

          if (params.search && params.search.length) {
            where.description = { _iregex: params.search };
          }
          if (params.filter.camera && params.filter.camera != "All") {
            where.camera_id = { _eq: params.filter.camera };
          }
          if (params.filter.customer_id != "All Customers") {
            where.customer_id = { _eq: params.filter.customer_id };
          }
          if (params.filter.level) {
            where.level = { _eq: params.filter.level };
          }
          if (params.filter.email_filter != "All") {
            where.sent_datetime_sendgrid = {
              _is_null: !params.filter.email_filter,
            };
          }
          if (params.filter.txt_filter != "All") {
            where.sent_datetime_twilio = {
              _is_null: !params.filter.txt_filter,
            };
          }
          if (params.filter.feedback_received_filter != "All") {
            where.feedback_received = {
              _eq: params.filter.feedback_received_filter,
            };
          }
          if (params.filter.feedback_positive_filter != "All") {
            where.feedback_positive = {
              _eq: params.filter.feedback_positive_filter,
            };
          }
          if (params.date) {
            where.datetime = {
              _gte: moment(params.date, "YYYY-MM-DDTHH").format(
                "YYYY-MM-DDTHH:ss:mm"
              ),
              _lt: moment(params.date, "YYYY-MM-DDTHH")
                .add(1, "d")
                .format("YYYY-MM-DDTHH:ss:mm"),
            };
          }
          let notifications = (
            await axios.post(
              store.state.hasura_params.url,
              {
                query: hasura_queries.notification,
                variables: {
                  where: where,
                  order_by: order_by,
                  limit: params.limit,
                  offset: params.offset,
                },
              },
              {
                headers: store.state.hasura_params.headers,
              }
            )
          ).data;
          let notification_count = (
            await axios.post(
              store.state.hasura_params.url,
              {
                query: hasura_queries.notification_aggregate,
                variables: {
                  where: where,
                },
              },
              {
                headers: store.state.hasura_params.headers,
              }
            )
          ).data.data.notification_aggregate.aggregate.count;

          commit("SET_NOTIFICATIONS", {
            notifications: notifications.data.notification,
            notification_count: notification_count,
          });
          resolve();
        }
        get_events(params);
      });
    },

    DDB_GET_ANALYTICS_CALVING({ commit }, params) {
      return new Promise((resolve) => {
        var _this = this;
        async function get_events(params) {
          _this.state.event_params = params;

          let order_by = {};
          if (params.sort) {
            order_by[params.sort] = params.sort_direction;
          }
          let where = {};

          if (params.filter.camera && params.filter.camera != "All") {
            where.camera_id = { _eq: params.filter.camera };
          }
          if (params.filter.customer_id != "All Customers") {
            where.customer_id = { _eq: params.filter.customer_id };
          }
          if (params.filter.contraction_1_filter != "All") {
            where.contraction_label = {
              _eq: params.filter.contraction_1_filter,
            };
          }
          if (params.filter.contraction_2_filter != "All") {
            where.contraction_label_2 = {
              _eq: params.filter.contraction_2_filter,
            };
          }
          if (params.filter.valid_event_filter != "All") {
            where.valid_calving_event = {
              _eq: params.filter.valid_event_filter,
            };
          }

          if (params.date) {
            where.notification_timestamp = {
              _gte: moment(params.date, "YYYY-MM-DDTHH").format(
                "YYYY-MM-DDTHH:ss:mm"
              ),
              _lt: moment(params.date, "YYYY-MM-DDTHH")
                .add(1, "d")
                .format("YYYY-MM-DDTHH:ss:mm"),
            };
          }

          let analytics_calving = (
            await axios.post(
              store.state.hasura_params.url,
              {
                query: hasura_queries.analytics_calving,
                variables: {
                  where: where,
                  order_by: order_by,
                  limit: params.limit,
                  offset: params.offset,
                },
              },
              {
                headers: store.state.hasura_params.headers,
              }
            )
          ).data;
          let analytics_calving_count = (
            await axios.post(
              store.state.hasura_params.url,
              {
                query: hasura_queries.analytics_calving_aggregate,
                variables: {
                  where: where,
                },
              },
              {
                headers: store.state.hasura_params.headers,
              }
            )
          ).data.data.analytics_calving_aggregate.aggregate.count;

          commit("SET_ANALYTICS_CALVING", {
            analytics_calving: analytics_calving.data.analytics_calving,
            analytics_calving_count: analytics_calving_count,
          });
          resolve();
        }
        get_events(params);
      });
    },

    DDB_GET_ANALYTICS_ESTRUS({ commit }, params) {
      return new Promise((resolve) => {
        var _this = this;
        async function get_events(params) {
          _this.state.event_params = params;

          let order_by = {};
          if (params.sort) {
            order_by[params.sort] = params.sort_direction;
          }
          let where = {};

          if (params.filter.camera && params.filter.camera != "All") {
            where.camera_id = { _eq: params.filter.camera };
          }
          if (params.filter.customer_id != "All Customers") {
            where.customer_id = { _eq: params.filter.customer_id };
          }
          if (params.filter.gpt_check) {
            where.gpt_check = { _eq: true };
          }
          if (params.filter.label != "All") {
            where.class_label = { _eq: params.filter.label };
          }

          if (params.date) {
            where.notification_timestamp = {
              _gte: moment(params.date, "YYYY-MM-DDTHH").format(
                "YYYY-MM-DDTHH:ss:mm"
              ),
              _lt: moment(params.date, "YYYY-MM-DDTHH")
                .add(1, "d")
                .format("YYYY-MM-DDTHH:ss:mm"),
            };
          }

          let analytics_estrus = (
            await axios.post(
              store.state.hasura_params.url,
              {
                query: hasura_queries.analytics_estrus,
                variables: {
                  where: where,
                  order_by: order_by,
                  limit: params.limit,
                  offset: params.offset,
                },
              },
              {
                headers: store.state.hasura_params.headers,
              }
            )
          ).data;
          let analytics_estrus_count = (
            await axios.post(
              store.state.hasura_params.url,
              {
                query: hasura_queries.analytics_estrus_aggregate,
                variables: {
                  where: where,
                },
              },
              {
                headers: store.state.hasura_params.headers,
              }
            )
          ).data.data.analytics_estrus_aggregate.aggregate.count;

          commit("SET_ANALYTICS_ESTRUS", {
            analytics_estrus: analytics_estrus.data.analytics_estrus,
            analytics_estrus_count: analytics_estrus_count,
          });
          resolve();
        }
        get_events(params);
      });
    },
    DDB_GET_ANALYTICS_PREDATOR({ commit }, params) {
      return new Promise((resolve) => {
        var _this = this;
        async function get_events(params) {
          _this.state.event_params = params;

          let order_by = {};
          if (params.sort) {
            order_by[params.sort] = params.sort_direction;
          }
          let where = {};

          if (params.filter.camera && params.filter.camera != "All") {
            where.camera_id = { _eq: params.filter.camera };
          }
          if (params.filter.customer_id != "All Customers") {
            where.customer_id = { _eq: params.filter.customer_id };
          }

          if (params.date) {
            where.notification_timestamp = {
              _gte: moment(params.date, "YYYY-MM-DDTHH").format(
                "YYYY-MM-DDTHH:ss:mm"
              ),
              _lt: moment(params.date, "YYYY-MM-DDTHH")
                .add(1, "d")
                .format("YYYY-MM-DDTHH:ss:mm"),
            };
          }

          let analytics_predator = (
            await axios.post(
              store.state.hasura_params.url,
              {
                query: hasura_queries.analytics_predator,
                variables: {
                  where: where,
                  order_by: order_by,
                  limit: params.limit,
                  offset: params.offset,
                },
              },
              {
                headers: store.state.hasura_params.headers,
              }
            )
          ).data;
          let analytics_predator_count = (
            await axios.post(
              store.state.hasura_params.url,
              {
                query: hasura_queries.analytics_predator_aggregate,
                variables: {
                  where: where,
                },
              },
              {
                headers: store.state.hasura_params.headers,
              }
            )
          ).data.data.analytics_predator_aggregate.aggregate.count;

          commit("SET_ANALYTICS_PREDATOR", {
            analytics_predator: analytics_predator.data.analytics_predator,
            analytics_predator_count: analytics_predator_count,
          });
          resolve();
        }
        get_events(params);
      });
    },

    async authState({ commit, dispatch }, state) {
      if (state === "signedIn") await dispatch("fetchUser");
      else commit("user", null);
    },





    DDB_GET_SUMMARY_MEDIA({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let query = `summary_media_${params.timeframe}_${params.customer == "All Customers" || !params.customer
            ? "admin"
            : "user"
            }`;
          //console.log(query)
          let variables =
            params.customer == "All Customers" || !params.customer
              ? { limit: params.limit * 2 }
              : {
                limit: params.limit * 2,
                where: { customer_id: { _eq: params.customer } },
              };

          let data = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries[query],
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_SUMMARY_MEDIA", data.data.data[query]);
          resolve();
        }
        get_data();
      });
    },

    DDB_GET_SUMMARY_PGIE({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let query = `summary_pgie_${params.timeframe}_${params.customer == "All Customers" || !params.customer
            ? "admin"
            : "user"
            }`;

          let variables =
            params.customer == "All Customers" || !params.customer
              ? { limit: params.limit }
              : {
                limit: params.limit,
                where: { customer_id: { _eq: params.customer } },
              };
          let data = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries[query],
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_SUMMARY_PGIE", data.data.data[query]);
          resolve();
        }
        get_data();
      });
    },

    DDB_GET_SUMMARY_ACTIVITY({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let query = `summary_activity_${params.timeframe}_${params.customer == "All Customers" || !params.customer
            ? "admin"
            : "user"
            }`;

          let variables =
            params.customer == "All Customers" || !params.customer
              ? { limit: params.limit }
              : {
                limit: params.limit,
                where: { customer_id: { _eq: params.customer } },
              };
          let data = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries[query],
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_SUMMARY_ACTIVITY", data.data.data[query]);
          resolve();
        }
        get_data();
      });
    },
    DDB_GET_SUMMARY_CALVING({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let query = `summary_calving_${params.timeframe}_${params.customer == "All Customers" || !params.customer
            ? "admin"
            : "user"
            }`;

          let variables =
            params.customer == "All Customers" || !params.customer
              ? { limit: params.limit }
              : {
                limit: params.limit,
                where: { customer_id: { _eq: params.customer } },
              };
          let data = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries[query],
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_SUMMARY_CALVING", data.data.data[query]);
          resolve();
        }
        get_data();
      });
    },
    DDB_GET_SUMMARY_ESTRUS({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let query = `summary_estrus_${params.timeframe}_${params.customer == "All Customers" || !params.customer
            ? "admin"
            : "user"
            }`;

          let variables =
            params.customer == "All Customers" || !params.customer
              ? { limit: params.limit }
              : {
                limit: params.limit,
                where: { customer_id: { _eq: params.customer } },
              };
          let data = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries[query],
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_SUMMARY_ESTRUS", data.data.data[query]);
          resolve();
        }
        get_data();
      });
    },
    DDB_GET_SUMMARY_SPECIES({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let query = `summary_species_${params.timeframe}_${params.customer == "All Customers" || !params.customer
            ? "admin"
            : "user"
            }`;

          let variables =
            params.customer == "All Customers" || !params.customer
              ? { limit: params.limit }
              : {
                limit: params.limit,
                where: { customer_id: { _eq: params.customer } },
              };
          let data = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries[query],
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_SUMMARY_SPECIES", data.data.data[query]);
          resolve();
        }
        get_data();
      });
    },

    DDB_GET_MEDIA_BY_CAMERA_SUMMARY({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let variables = { where: { media_date: { _eq: params.date } } };
          let data = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries["summary_media_summary"],
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit(
            "SET_MEDIA_BY_CAMERA_SUMMARY",
            data.data.data["summary_media_summary"]
          );
          resolve();
        }
        get_data();
      });
    },

    DDB_GET_SUMMARY_VPC({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let query = `summary_vpc_1day_admin`;

          let variables = { limit: params.limit * 20 };

          let data = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries[query],
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_SUMMARY_VPC", data.data.data[query]);
          resolve();
        }
        get_data();
      });
    },

    DDB_GET_SUMMARY_VEHICLE({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {

          let query = `summary_vehicle_details_${params.timeframe}_${params.customer == "All Customers" || !params.customer
            ? "admin"
            : "user"
            }`;

          let variables =
            params.customer == "All Customers" || !params.customer
              ? { limit: params.limit }
              : {
                limit: params.limit,
                where: { customer_id: { _eq: params.customer } },
              };

          let data = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries[query],
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_SUMMARY_VEHICLE", data.data.data[query]);
          resolve();
        }
        get_data();
      });
    },

    DDB_GET_SUMMARY_TAG({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {

          let query = `summary_tag_${params.timeframe}_${params.customer == "All Customers" || !params.customer
            ? "admin"
            : "user"
            }`;

          let variables =
            params.customer == "All Customers" || !params.customer
              ? { limit: params.limit }
              : {
                limit: params.limit,
                where: { customer_id: { _eq: params.customer } },
              };

          let data = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries[query],
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          console.log(data)
          commit("SET_SUMMARY_TAG", data.data.data[query]);
          resolve();
        }
        get_data();
      });
    },

    DDB_GET_NOTIFICATION_ANALYTICS({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let variables = {
            args: {
              date_start: params.date_start,
              date_end: params.date_end,
              customer: params.customer,
            },
          };
          let variables_customer = {
            args: { date_start: params.date_start, date_end: params.date_end },
          };

          let type = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.notification_analytics,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let customer = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.notification_analytics_customer,
              variables: variables_customer,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let sent = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.notification_analytics_sent,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_NOTIFICATION_ANALYTICS", {
            type: type.data.data.notification_analytics,
            customer: customer.data.data.notification_analytics_customer,
            sent: sent.data.data.notification_analytics_sent,
          });
          resolve();
        }
        get_data();
      });
    },

    DDB_GET_CALVING_CHARTS({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let variables = {
            args: {
              date_start: params.date_start,
              date_end: params.date_end,
              customer: params.customer,
            },
          };
          let variables_customer = {
            args: { date_start: params.date_start, date_end: params.date_end },
          };

          let type = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.calving_analytics_chart,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let customer = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.calving_chart_customer,
              variables: variables_customer,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let sent = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.calving_chart_sent,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_CALVING_CHARTS", {
            type: type.data.data.calving_analytics_chart,
            customer: customer.data.data.calving_chart_customer,
            sent: sent.data.data.calving_chart_sent,
          });
          resolve();
        }
        get_data();
      });
    },
    DDB_GET_ESTRUS_CHARTS({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let variables = {
            args: {
              date_start: params.date_start,
              date_end: params.date_end,
              customer: params.customer,
            },
          };
          let variables_customer = {
            args: { date_start: params.date_start, date_end: params.date_end },
          };

          let type = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.estrus_analytics_chart,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let customer = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.estrus_chart_customer,
              variables: variables_customer,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let sent = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.estrus_chart_sent,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_ESTRUS_CHARTS", {
            type: type.data.data.estrus_analytics_chart,
            customer: customer.data.data.estrus_chart_customer,
            sent: sent.data.data.estrus_chart_sent,
          });
          resolve();
        }
        get_data();
      });
    },
    DDB_GET_PREDATOR_CHARTS({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let variables = {
            args: {
              date_start: params.date_start,
              date_end: params.date_end,
              customer: params.customer,
            },
          };
          let variables_customer = {
            args: { date_start: params.date_start, date_end: params.date_end },
          };

          let type = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.predator_analytics_chart,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let customer = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.predator_chart_customer,
              variables: variables_customer,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let sent = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.predator_chart_sent,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_PREDATOR_CHARTS", {
            type: type.data.data.predator_analytics_chart,
            customer: customer.data.data.predator_chart_customer,
            sent: sent.data.data.predator_chart_sent,
          });
          resolve();
        }
        get_data();
      });
    },

    DDB_GET_ANIMAL_ID_CHARTS({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let variables = {
            args: {
              date_start: params.date_start,
              date_end: params.date_end,
              customer: params.customer,
            },
          };
          let variables_customer = {
            args: { date_start: params.date_start, date_end: params.date_end },
          };

          let type = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.tag_id_count,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let customer = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.tag_id_count_by_customer,
              variables: variables_customer,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let unique = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.tag_id_count_unique,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let unique_label = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.tag_id_count_unique_label,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let unique_color = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.tag_id_count_unique_color,
              variables: variables,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          commit("SET_ANIMAL_ID_CHARTS", {
            type: type.data.data.tag_id_count,
            customer: customer.data.data.tag_id_count_by_customer,
          });
          commit("SET_ANIMAL_ID_UNIQUE_CHARTS", {
            combo: unique.data.data.tag_id_count_unique,
            label: unique_label.data.data.tag_id_count_unique_label,
            color: unique_color.data.data.tag_id_count_unique_color,
          });
          resolve();
        }
        get_data();
      });
    },

    DDB_GET_ANIMAL_ID_USERDB({ commit }, params) {
      return new Promise((resolve) => {
        async function get_data() {
          let var_total = {
            args: {
              date_start: params.date_start,
              customer_id: params.customer,
            },
          };
          let var_pending = {
            args: {
              date_start: params.date_start,
              customer_id: params.customer,
              review_status: 'PENDING'
            },
          };
          let var_approved = {
            args: {
              date_start: params.date_start,
              customer_id: params.customer,
              review_status: 'APPROVED'
            },
          };
          let var_denied = {
            args: {
              date_start: params.date_start,
              customer_id: params.customer,
              review_status: 'DENIED'
            },
          };


          let total = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.animal_identifiation_count_userdb,
              variables: var_total,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let pending = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.animal_identifiation_count_userdb,
              variables: var_pending,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          let approved = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.animal_identifiation_count_userdb,
              variables: var_approved,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );

          let denied = await axios.post(
            store.state.hasura_params.url,
            {
              query: hasura_queries.animal_identifiation_count_userdb,
              variables: var_denied,
            },
            {
              headers: store.state.hasura_params.headers,
            }
          );
          console.log(total.data.data.animal_identifiation_count_userdb)
          commit("SET_ANIMAL_ID_USERDB", {
            total: total.data.data.animal_identifiation_count_userdb,
            pending: pending.data.data.animal_identifiation_count_userdb,
            approved: approved.data.data.animal_identifiation_count_userdb,
            denied: denied.data.data.animal_identifiation_count_userdb
          });
          resolve();
        }
        get_data();
      });
    },
  },

  getters: {
    getUsersChecked: (state) => state.usersChecked,
    getAnimalIDUserDB(state) {
      return state.animal_id_userdb;
    },
    getAnimalIDUniqueCharts(state) {
      return state.animal_id_unique_charts;
    },
    getAnimalIDCharts(state) {
      return state.animal_id_charts;
    },
    getCalvingCharts(state) {
      return state.calving_charts;
    },
    getEstrusCharts(state) {
      return state.estrus_charts;
    },
    getPredatorCharts(state) {
      return state.predator_charts;
    },
    getNotificationAnalytics(state) {
      return state.notification_analytics;
    },
    getMediaByCameraSummary(state) {
      return state.media_by_camera_summary;
    },
    getImageCount(state) {
      return state.animal_images_count;
    },
    getAnimalImages(state) {
      return state.animal_images;
    },
    getTritonModels(state) {
      return state.triton_model_list;
    },
    getTritonMetrics(state) {
      return state.triton_metric_list;
    },
    getVideoYears(state) {
      return state.video_years;
    },
    getAnimalTags(state) {
      return state.animal_tags;
    },
    getWifiModels(state) {
      return state.wifi_models;
    },
    getCurrentCustomer(state) {
      return state.current_customer;
    },
    getTimeRanges(state) {
      return state.time_ranges;
    },
    getTimeSettings(state) {
      return state.time_settings;
    },
    getPGIETypeList(state) {
      return state.PGIE_type_list;
    },
    getSpeciesTypeList(state) {
      return state.Species_type_list;
    },
    getSGIETypeList(state) {
      return state.SGIE_type_list;
    },
    getVehicleTypeList(state) {
      return state.Vehicle_type_list;
    },
    getVehicleMakeList(state) {
      return state.Vehicle_make_list;
    },
    getHumanPoseList(state) {
      return state.Human_pose_list;
    },
    getModelVersionList(state) {
      return state.model_version_list;
    },
    getNotificationFields(state) {
      return state.notification_fields;
    },
    getBBOXColorCode(state) {
      return state.bbox_color_code;
    },
    getImagesImagePlayer(state) {
      return state.imagesImagePlayer;
    },
    getImages(state) {
      return state.images;
    },
    getVideosTimestream(state) {
      return state.videos_timestream;
    },
    getVideosVideoBoard(state) {
      return state.videosBoard;
    },
    getVideosVideoTable(state) {
      return state.videosTable;
    },
    getWaitInterval(state) {
      return state.wait_interval;
    },
    getCustomerTypes(state) {
      return state.customer_types;
    },
    getNotificationLevels(state) {
      return state.notification_levels;
    },
    getNotificationFrequency(state) {
      return state.notification_frequency;
    },
    getJwtToken(state) {
      return state.jwt_token;
    },
    getCustomerTreeview(state) {
      return state.treeview_customer;
    },
    getFeedbacks(state) {
      return state.feedbacks;
    },
    getNotes(state) {
      return state.notes;
    },
    getSelectedNotes(state) {
      return state.selected_notes;
    },
    getSelectedCamera(state) {
      return state.selected_camera;
    },
    getLastFootageUploads(state) {
      return state.last_footage_upload_cameras;
    },
    getContactNames(state) {
      return state.contact_names;
    },
    getSelectedContacts(state) {
      return state.selected_contacts;
    },
    getSelectedProjects(state) {
      return state.selected_projects;
    },
    getAllCorrespondence(state) {
      return state.all_correspondences;
    },
    getCorrespondences(state) {
      return state.correspondences;
    },
    getProjectNamesID(state) {
      return state.project_id_names;
    },
    getProjectContacts(state) {
      return state.selected_project_contacts;
    },
    getCameraIds(state) {
      return state.camera_ids;
    },
    getProjects(state) {
      return state.projects;
    },
    getContacts(state) {
      return state.contacts;
    },
    getHerds(state) {
      return state.herds;
    },
    getAnimals(state) {
      return state.animals;
    },
    getCustomer(state) {
      return state.selected_customer;
    },
    getEditedCustomer(state) {
      return state.edited_customer;
    },
    getEvents(state) {
      return state.events;
    },
    getVideos(state) {
      return state.videos;
    },
    getSiteNameObject(state) {
      return state.site_name_object;
    },
    getNameSiteObject(state) {
      return state.name_site_object;
    },
    getSiteNames(state) {
      return state.site_names;
    },
    getOwnerNameObject(state) {
      return state.owner_name_object;
    },
    getNameOwnerObject(state) {
      return state.name_owner_object;
    },
    getCustomerNames(state) {
      return state.customer_names;
    },
    getCoordinates(state) {
      return state.coordinates;
    },
    getUser(state) {
      return state.user;
    },
    getUserDDB(state) {
      return state.user_ddb;
    },
    getStagingData(state) {
      return state.staging_data;
    },
    getProductionData(state) {
      return state.production_data;
    },
    getSiteObjects(state) {
      return state.site_objects;
    },
    getCameraObjects(state) {
      return state.camera_objects;
    },
    getCameraCount(state) {
      return state.camera_count;
    },
    getCameraModels(state) {
      return state.camera_models;
    },
    getCameraResolutions(state) {
      return state.camera_resolutions;
    },
    getCameraSources(state) {
      return state.camera_sources;
    },
    getCameraShippingStatus(state) {
      return state.camera_shipping_status;
    },
    getCameraOnlineStatus(state) {
      return state.camera_online_status;
    },
    getWifiShippingStatus(state) {
      return state.wifi_shipping_status;
    },
    getWifiOnlineStatus(state) {
      return state.wifi_online_status;
    },
    getWifiManufacturers(state) {
      return state.wifi_manufacturers;
    },
    getJetsonOnlineStatus(state) {
      return state.jetson_online_status;
    },
    getJetsonShippingStatus(state) {
      return state.jetson_shipping_status;
    },
    getCustomerStatus(state) {
      return state.customer_status;
    },
    getShippingStatus(state) {
      return state.shipping_status;
    },
    getOnlineStatus(state) {
      return state.online_status;
    },
    getJetsonObjects(state) {
      return state.jetson_objects;
    },
    getProductionCameras(state) {
      return state.production_cameras;
    },
    getCustomerObjects(state) {
      return state.customer_objects;
    },
    getCognitoUsers(state) {
      return state.cognito_users;
    },
    getStagingRanches(state) {
      return state.staging_ranches;
    },
    getProductionRanches(state) {
      return state.production_ranches;
    },
    getWifiObjects(state) {
      return state.wifi_objects;
    },
    getFootage(state) {
      return state.footage;
    },
    getCustomerCardDialog(state) {
      return state.customer_card_dialog;
    },
    getUserCardDialog(state) {
      return state.user_card_dialog;
    },
    getNoteCardDialog(state) {
      return state.note_card_dialog;
    },
    getImageCardMinimalDialog(state) {
      return state.image_card_minimal_dialog;
    },
    getGeneralFilterDialog(state) {
      return state.general_filter_dialog;
    },
    getSiteCardDialog(state) {
      return state.site_card_dialog;
    },
    getCameraCardDialog(state) {
      return state.camera_card_dialog;
    },
    getWifiCardDialog(state) {
      return state.wifi_card_dialog;
    },
    getJetsonCardDialog(state) {
      return state.jetson_card_dialog;
    },
    getCollaborationCardDialog(state) {
      return state.collaboration_card_dialog;
    },
    getDialogStatus(state) {
      return (
        state.customer_card_dialog ||
        state.user_card_dialog ||
        state.site_card_dialog ||
        state.camera_card_dialog ||
        state.nuke_card_dialog ||
        state.wifi_card_dialog ||
        state.jetson_card_dialog ||
        state.collaboration_card_dialog ||
        state.note_card_dialog ||
        state.image_card_dialog ||
        state.image_card_minimal_dialog ||
        state.general_filter_dialog
      );
    },
    getProvinces(state) {
      return state.provinces;
    },
    getStates(state) {
      return state.states;
    },
    getHasuraParams(state) {
      return state.hasura_params;
    },
    getHasuraParamsWrite(state) {
      return state.hasura_params_write;
    },
    getNotifications(state) {
      return state.notifications;
    },
    getNotificationCount(state) {
      return state.notification_count;
    },
    getCalvingAnalytics(state) {
      return state.analytics_calving;
    },
    getCalvingAnalyticsCount(state) {
      return state.analytics_calving_count;
    },
    getEstrusAnalytics(state) {
      return state.analytics_estrus;
    },
    getEstrusAnalyticsCount(state) {
      return state.analytics_estrus_count;
    },
    getPredatorAnalytics(state) {
      return state.analytics_predator;
    },
    getPredatorAnalyticsCount(state) {
      return state.analytics_predator_count;
    },
    getSelectionCameras(state) {
      return state.selection_cameras;
    },
    getSummaryMedia(state) {
      return state.summary_media;
    },
    getSummaryPGIE(state) {
      return state.summary_pgie;
    },
    getSummaryActivity(state) {
      return state.summary_activity;
    },
    getSummaryCalving(state) {
      return state.summary_calving;
    },
    getSummaryEstrus(state) {
      return state.summary_estrus;
    },
    getSummarySpecies(state) {
      return state.summary_species;
    },
    getSummaryVPC(state) {
      return state.summary_vpc;
    },
    getSummaryVehicle(state) {
      return state.summary_vehicle;
    },
    getSummaryTag(state) {
      return state.summary_tag;
    },
    getHomePageStats(state) {
      return state.home_page_stats;
    },
    getByCameraData(state) {
      return state.by_camera;
    },
    // for displaying a single cow
  },
});

export default store;
